<template>
    <div class="cabinet-content-wrap">
        <header
            v-show="
                !isMobile || (isMobile && $route.name == 'SupplierProductsEdit')
            "
            class="cabinet-header flex flex-align-center"
        >
            <a
                href="javascript:void(0)"
                class="cabinet-btn--form-back-header-edit"
                @click.prevent="handleBack()"
            ></a>
            <h1 class="h1 cabinet-title">Изделие #{{ $route.params.id }}</h1>
        </header>

        <section
            v-show="
                !isMobile || (isMobile && $route.name == 'SupplierProductsEdit')
            "
            class="supplier-nav flex flex-align-center"
        >
            <router-link
                :to="{ name: 'SupplierProductsEditSpecifications' }"
                class="supplier-nav__link"
            >
                Характеристики
            </router-link>
            <router-link
                :to="{ name: 'SupplierProductsEditInserts' }"
                class="supplier-nav__link"
            >
                Вставки
            </router-link>
            <router-link
                :to="{ name: 'SupplierProductsEditImages' }"
                class="supplier-nav__link"
            >
                Изображения
            </router-link>
            <router-link
                :to="{ name: 'SupplierProductsEditVisibility' }"
                class="supplier-nav__link"
            >
                Видимость
            </router-link>
        </section>

        <transition name="fade-d">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import supplierProductDictionaries from '@/mixins/supplier-product-dictionaries'
import onResize from '@/mixins/on-resize'
import { mapActions } from 'vuex'

export default {
    name: 'SupplierProductsEdit',
    mixins: [onResize, supplierProductDictionaries],
    data() {
        return {
            //роут, с которого был совершен переход на родительский роут
            fromRoute: JSON.parse(
                window.localStorage.getItem('fromRoute') || '{}'
            )
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            window.localStorage.setItem(
                'fromRoute',
                JSON.stringify({ ...from })
            )
            vm.fromRoute = { ...from }
        })
    },
    async mounted() {
        if (this.$route.name === 'SupplierProductsEdit' && !this.isMobile) {
            return this.$router.push({
                name: 'SupplierProductsEditSpecifications',
                params: { id: this.$route.params.id }
            })
        }

        await this.getProduct(this.$route.params.id)
    },
    methods: {
        ...mapActions('supplierProducts', ['getProduct']),
        handleBack() {
            if (this.fromRoute.name === 'SupplierProductsDetail') {
                this.$router.push({
                    name: this.fromRoute.name,
                    params: { id: this.$route.params.id }
                })
            } else {
                this.$router.push({ name: 'SupplierProducts' })
            }
        }
    }
}
</script>
